export default {
  Register: 'Register License',
  Licenses: 'Licenses',
  Request: 'Requests',
  Dashboard: 'Dashboard',
  Report: 'Report',
  Settings: 'Manage Accounts',
  Logout: 'Logout',
  Tickets: 'Tickets',
  ChangePassword: 'Change Password',
  Partner: 'Partner',
  DateFormat: 'Date format',
  TwoFactorAuthentication: 'Two-factor authentication',
};